import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection, SolutionSection, DeliverablesSection } from '../components/ContentSection';
import { PricingCard } from '../components/PricingCard';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-slate-900 text-slate-50 font-sans selection:bg-amber-500/30" data-id="element-144">
      <header className="absolute top-0 w-full z-50 py-6" data-id="element-145">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-146">
          <div className="font-bold text-xl tracking-tight text-white/90" data-id="element-147">
            NocheTranquila<span className="text-amber-400" data-id="element-148">65+</span>
          </div>
        </div>
      </header>

      <main data-id="element-149">
        <Hero data-id="element-150" />
        <ProblemSection data-id="element-151" />
        <SolutionSection data-id="element-152" />
        <DeliverablesSection data-id="element-153" />
        <PricingCard data-id="element-154" />
      </main>

      <Footer data-id="element-155" />
    </div>;
}